<template>
  <li :id="item.id">
    <div class="lable_detail" :class="{'index': item.id === pid}">
      <div class="lable_detail_num" draggable='true' @dragstart="getStart($event, item.id, item.name, item.pid)" @dragover="getOver($event, item.id)" @dragend="getEnd($event, item.id)">
        <p class="lable_detail_p" @click="statisticsPush(item.id, item.name)">{{item.name}}</p>
        <span>{{item.childLength}}
          <i v-if="item.childLength>0" :id="'i'+ item.id" class="el-icon-arrow-down" style="margin-right: 5px;float: right;font-size: 12px;cursor:pointer" @click="Hierarchy(item.id)"></i>
          <!-- <i v-if="item.children" class="el-icon-arrow-up" style="margin-right: 5px;float: right;font-size: 12px;"></i> -->
        </span>
        <span style="border: none;width: 25px;">{{item.user_num}}</span>
      </div>
      <div class="lable_detail_icon">
        <img v-if="item.pid !== 0" src="../../assets/images/yichu.png" style="height:13px;margin-right:5px" @click="lableRemove(item.id, item.name)">
        <i class="el-icon-edit" style="margin-right:5px;color:#018dfc;" @click="editLable(item.pid, item.name, item.id)"></i>
        <i class="el-icon-delete" style="color:red" @click="delectTag(item.id, item.childLength)"></i>
      </div>
    </div>
    <ul v-if="item.children" class="children">
      <tree-label v-for="(child, index) in item.children"  @delectCustomerTag="delectTag" @editLable="editLable" @getStart="getStart" @getOver="getOver" @getEnd="getEnd" v-model="item.children[index]" :key="index" :pid="pid" @Hierarchy="Hierarchy" @statisticsPush="statisticsPush" @lableRemove="lableRemove"></tree-label>
    </ul>
  </li>
</template>
<script>
export default {
  name: 'tree-label',
  props: ['value', 'pid'],
  data() {
    return {
      item: this.value
    }
  },
  computed: {
  },
  methods: {
    // 删除标签
    delectTag(id, childLength) {
      this.$emit('delectCustomerTag', id, childLength)
    },
    editLable(pid, name, id) {
      this.$emit('editLable', pid, name, id)
    },
    getStart (e, id, name, pid) {
      // this.editIdTree = id
      this.$emit('getStart', e, id, name, pid)
    },
    getOver(e, id) {
      this.$emit('getOver', e, id)
    },
    getEnd(e, id) {
      this.$emit('getEnd', e, id)
    },
    Hierarchy(id) {
      this.$emit('Hierarchy', id)
    },
    statisticsPush(id, name) {
      this.$emit('statisticsPush', id, name)
    },
    lableRemove(id, name) {
      this.$emit('lableRemove', id, name)
    }
  },
  mounted () {
  }
}
</script>

<style>
.children{
  display: block;
}
.index .lable_detail_num{
  background: #d0e5ff;
}
.trag .lable_detail_num{
  border: 1px dashed #1980FF;
}
/*li标签*/
.con_lable li{
  list-style: none;
}
.lable_detail{
  width: 340px;
  height: 35px;
  margin-top: 15px;
  font-size: 14px;
  text-align: left;
}
.lable_detail_num{
  background: #f6faff;
  width: 250px;
  border: 1px solid #ececec;
  box-sizing: border-box;
  border-radius: 5px;
  height: 35px;
  line-height: 35px;
  text-align: left;
  padding-left: 10px;
  display: inline-block;
  float: left;
  cursor: pointer;
}
.lable_detail_num .lable_detail_p{
  margin:0;
  display: inline-block;
  width: 161px;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.lable_detail:hover .lable_detail_num{
  border: 1px solid #1980FF;
}
.lable_detail:hover .lable_detail_icon{
  display: inline-block;
}
.lable_detail_num span{
  float: right;
  border-left: 1px solid #ececec;
  line-height: 15px;
  margin-top: 10px;
  width: 50px;
  text-align: center;
}
.lable_detail_icon{
  display: none;
  padding: 0 8px;
  cursor: pointer;
  line-height: 35px;
  height: 35px;
  margin: 0;
  float: left;
}
</style>
